import { STATS, STATS_BG } from "@/data/content";
import { useCountUp } from "@/hooks/useCountUp";

const StatCounter = ({ stat }) => {
  const [ref, value] = useCountUp(stat.value);
  return (
    <div ref={ref} data-testid={stat.testId} className="text-center">
      <div className="font-nunito text-5xl md:text-6xl font-black text-white tracking-tight">
        {value}
        <span className="text-[#ee2e24]">{stat.suffix}</span>
      </div>
      <h3 className="mt-3 font-nunito text-[12px] font-extrabold uppercase tracking-[0.24em] text-[#bdbdbd]">
        {stat.label}
      </h3>
    </div>
  );
};

export const StatsBand = () => {
  return (
    <section
      data-testid="stats-band"
      className="relative py-16 md:py-24 bg-[#0b0b0c] bg-parallax"
      style={{ backgroundImage: `url(${STATS_BG})` }}
    >
      <div className="absolute inset-0 bg-[rgba(2,2,2,0.82)]" />
      <div className="relative max-w-6xl mx-auto px-4 sm:px-6">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-6">
          {STATS.map((stat) => (
            <StatCounter key={stat.key} stat={stat} />
          ))}
        </div>
        <p className="mt-12 text-center font-nunito text-[11px] font-extrabold uppercase tracking-[0.3em] text-[#8a8a8a]">
          Leading the charge since 2006
        </p>
      </div>
    </section>
  );
};
